import React from "react";
import { Scissors, Palette, Feather, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "3D Printing",
  description: "Industrial-grade FDM and Resin printing capabilities for high-resolution functional prototypes and complex geometric models.",
  icon: Scissors,
  link: "#"
}, {
  title: "Laser Engraving",
  description: "High-precision material testing and permanent etching on wood, acrylic, and metals with mathematical accuracy and sharp detail.",
  icon: Palette,
  link: "#"
}, {
  title: "Light Design",
  description: "Architectural illumination and custom LED solutions engineered to transform environments through innovative light-burst technology.",
  icon: Feather,
  link: "#"
}];
export default function SignatureArtistry() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="27387" id="our-expert-capabilities" className="py-24 bg-background relative overflow-hidden">
      <div className="container mx-auto px-6 md:px-12">
        <div ref={ref} className={cn("text-center max-w-3xl mx-auto mb-16 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="text-4xl md:text-5xl font-sans font-bold text-foreground mb-6 tracking-tighter uppercase">
            Our Expert Capabilities
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans font-normal leading-relaxed">
            Where industrial precision meets creative imagination. We utilize advanced manufacturing 
            technologies to deliver specialized solutions for design-driven projects.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => {
          const Icon = service.icon;
          return <div key={index} data-index={index} className={cn("transition-all duration-700 ease-out delay-[100ms]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")} style={{
            transitionDelay: `${index * 150}ms`
          }}>
                <Card className="group h-full border-[1px] border-border/30 bg-card/50 rounded-none transition-all duration-300 hover:bg-secondary/20 hover:border-ring/50 hover:translate-y-0 flex flex-col justify-between shadow-none">
                  <CardHeader className="pt-10 pb-4 flex flex-col items-center text-center">
                    <div className="mb-6 p-4 rounded-none bg-background/30 ring-1 ring-border/20 group-hover:ring-ring/50 group-hover:bg-background/50 transition-all duration-300">
                      <Icon className="w-8 h-8 text-ring stroke-[1]" />
                    </div>
                    <CardTitle className="text-2xl font-sans font-bold text-foreground tracking-tight">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  
                  <CardContent className="text-center pb-8">
                    <p className="text-muted-foreground font-sans font-normal leading-relaxed">
                      {service.description}
                    </p>
                  </CardContent>
                  
                  <CardFooter className="flex justify-center pb-10 pt-0">
                    <Button variant="outline" className="border-border/40 rounded-none hover:bg-ring hover:text-primary-foreground hover:border-ring transition-all duration-300 font-mono tracking-widest uppercase text-[10px]" asChild>
                      <Link to={service.link}>
                        Specifications
                        <ArrowRight className="ml-2 w-3 h-3 transition-transform duration-300 group-hover:translate-x-1" />
                      </Link>
                    </Button>
                  </CardFooter>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}